"use strict";

const Popout = () => {
    const init = () => {
        $(function() {
            var $popout = $('.js-popout');

            window.resetPopoutTriggers = function(){
                var $popoutTriggers = $('.js-popout-trigger');
                
                $popoutTriggers.off('click');
                $popoutTriggers.on('click', function(){
                    $popout.removeClass('open');
                    $popout.filter('.js-popout[data-hash="'+$(this).data('popout')+'"]').addClass('open');
                });
            }

            resetPopoutTriggers();
            
            $popout.find('.js-popout-close').on('click', function(){
                $popout.removeClass('open');
            });

            window.closePopout = function(){
                $('.js-popout').removeClass('open');
            };

        });
    };

    return {
        init:init
    };
};

export default Popout;